<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<div class="side-bar-items-container w-100">
	@for (navItem of menuItems; track navItem.id) {
		<div class="w-full">
			<!-- Ítem principal -->
			<div
				class="side-bar-item-container flex flex-row h-14 items-center cursor-pointer"
				[ngClass]="{
					'selected-route-bg': selectedMenuOptionId === navItem.id && setBackground
				}"
				(click)="toggleOrNavigate(navItem)"
			>
				<mat-icon
					class="material-icons-outlined mr-3 ml-5"
					[ngClass]="{
						'selected-route-icon': selectedMenuOptionId === navItem.id && setBackground
					}"
					>{{ navItem.icon }}</mat-icon
				>
				<p
					[ngClass]="{
						'selected-route-title': selectedMenuOptionId === navItem.id && setBackground
					}"
				>
					{{ navItem.title }}
				</p>
				<!-- Flecha desplegable si tiene hijos -->
				<span *ngIf="navItem.children" class="ml-auto mr-5">
					<mat-icon>{{
						expandedItems.has(navItem.id) ? 'expand_less' : 'expand_more'
					}}</mat-icon>
				</span>
			</div>

			<!-- Subitems -->
			<div *ngIf="navItem.children && expandedItems.has(navItem.id)" class="ml-12">
				@for (child of navItem.children; track child.id) {
					<div
						class="side-bar-item-container flex flex-row h-12 items-center cursor-pointer"
						[ngClass]="{
							'selected-route-bg': selectedMenuOptionId === child.id && setBackground
						}"
						(click)="navigateTo(child)"
					>
						<mat-icon
							class="material-icons-outlined mr-3"
							[ngClass]="{
								'selected-route-icon': selectedMenuOptionId === child.id && setBackground
							}"
							>{{ child.icon }}</mat-icon
						>
						<p
							[ngClass]="{
								'selected-route-title': selectedMenuOptionId === child.id && setBackground
							}"
						>
							{{ child.title }}
						</p>
					</div>
				}
			</div>
		</div>
	}
</div>
